// helpers.js

// Function to generate a random rating between 3 and 5 (inclusive)
export function getRandomRating() {
    return Math.floor(Math.random() * 3) + 3; // Returns a random integer between 3 and 5
  }
  